export default __webpack_public_path__ + "static/media/Plissee.1eca0c58.jpeg";